<form
  [formGroup]="frm"
  (ngSubmit)="save()">
  <div class="formgrid grid">
    <div
      class="col-12 skeleton-border flex py-2 px-2 mb-3"
      *ngIf="schedule.related_registry">
      <h4 class="my-0 mr-3">Azienda:</h4>
      <h4 class="my-0 grey-text">{{ schedule.related_registry.name }}</h4>
    </div>

    <!-- assigned_user -->
    <div class="col-12 mb-3">
      <label>Tecnico assegnatario</label>
      <p-button
        type="button"
        styleClass="butt w-full"
        [rounded]="true"
        (click)="openAssignedUserModal()">
        <span>Scegli tecnico assegnatario</span>
      </p-button>
      <div
        class="skeleton-border flex py-2 px-2 mt-2"
        *ngIf="frm.value.assigned_user">
        <h4 class="my-0 mr-3">Tecnico assegnato:</h4>
        <h4 class="my-0 grey-text">
          {{ frm.value.assigned_user.name }} {{ frm.value.assigned_user.last_name }}
        </h4>
      </div>
    </div>

    <!-- schedule_status_id: accetta/rifiuta -->
    <div class="field col-12">
      <label>Accetta o rifiuta la schedulazione</label>
      <p-selectButton
        styleClass="w-full"
        [options]="acceptRejectOptions"
        formControlName="schedule_status_id"></p-selectButton>
    </div>

    <!-- notes -->
    <div class="col-12 mb-3">
      <label>Note</label>
      <textarea
        pInputTextarea
        class="w-full"
        rows="3"
        formControlName="notes"></textarea>
    </div>
  </div>

  <div class="flex justify-content-end gap-2 mt-3">
    <p-button
      type="button"
      label="Annulla"
      styleClass="p-button-outlined"
      (click)="close()"></p-button>
    <p-button
      type="submit"
      label="Salva"
      [loading]="saving"></p-button>
  </div>
</form>
